export class EquipmentTempGroupConfig {
    public Id: number;
    public EquipmentTempGroupId: number;
    public EquipmentTemplateId: number;
}
